import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import VideoVert from "../components/VideoVert";
import Anchorsandbarcode from "../img/Anchorsandbarcode.png";
import Attachments from "../img/Attachments.png";
import Autocaptured from "../img/Autocaptured.jpg";
import AutovsManualMode from "../img/AutovsManualMode.jpg";
import Cameraangle from "../img/Cameraangle.jpg";
import Clicksubmit from "../img/Clicksubmit.jpg";
import customAS from "../img/customAS.png";
import genericAS from "../img/genericAS.png";
import gtip1 from "../img/gtip1.png";
import gtip2 from "../img/gtip2.png";
import Hidestudentanswers from "../img/Hidestudentanswers.png";
import Hidestudentanswerteacher from "../img/Hidestudentanswerteacher.png";
import onlineAS from "../img/onlineAS.png";
import Password from "../img/Password.png";
import PrintMCas from "../img/PrintMCas.png";
import Printmultiplechoiceanswersheets from "../img/Printmultiplechoiceanswersheets.png";
import Printmultiplechoiceanswersheets2 from "../img/Printmultiplechoiceanswersheets2.png";
import Printregularanswersheets from "../img/Printregularanswersheets.png";
import Printregularanswersheets2 from "../img/Printregularanswersheets2.png";
import Printregularanswersheets3 from "../img/Printregularanswersheets3.png";
import Printregularanswersheets4 from "../img/Printregularanswersheets4.png";
import Printregularanswersheets5 from "../img/Printregularanswersheets5.png";
import Release from "../img/Release.png";
import release1 from "../img/release1.png";
import Releaseontestsettingspage from "../img/Releaseontestsettingspage.png";
import Resultsshownaftereachscan from "../img/Resultsshownaftereachscan.jpg";
import Review from "../img/Review.png";
import Scan1 from "../img/Scan1.jpg";
import Scan2 from "../img/Scan2.jpg";
import Selectaclass from "../img/Selectaclass.jpg";
import Selectclassrespond from "../img/Selectclassrespond.png";
import Start1 from "../img/Start1.png";
import Start2 from "../img/Start2.png";
import Studentsanswerrespond from "../img/Studentsanswerrespond.png";
import Submittoviewresults from "../img/Submittoviewresults.png";
import Time from "../img/Time.png";
import tip1 from "../img/tip1.png";
import tip2 from "../img/tip2.png";
import tip3 from "../img/tip3.png";
import tip4 from "../img/tip4.png";
import Unrelease from "../img/Unrelease.png";
import Viewresultsrespond from "../img/Viewresultsrespond.png";
import blankAS from "../img/blankAS.png";
import prefilledAS from "../img/prefilledAS.png";
import custommc3 from "../img/custommc3.png";
import custommc2 from "../img/custommc2.png";
import custommc1 from "../img/custommc1.png";

const useStyles = makeStyles((theme) => ({
  topicMain: {},
  root: {
    minHeight: "50vh",
    marginTop: "70px",
    paddingBottom: "50px",
    width: "100%",
    maxWidth: "800px",
    "& a": {
      color: "#4381b5",
    },
    "& h2": {
      marginBottom: "30px",
    },
    "& h4": {
      margin: "30px 0px",
    },
    "& img": {
      boxShadow: "0 3px 10px rgb(0 0 0 / 0.4)",
      borderRadius: "4px",

      // transition: "transform .2s",
      // "&:hover": {
      //   transform: "scale(1.3)",
      // },
    },
    "& ul": { marginLeft: "20px" },
    "& li": {
      marginLeft: "20px",
    },
  },
  imgSize: {
    maxWidth: "350px",
    width: "90%",
    display: "block",
    margin: "20px auto",
    marginBottom: "40px",
  },
  imgSize2: {
    maxWidth: "370px",
    width: "90%",
    margin: "20px auto",
    display: "block",
    marginTop: "20px",
  },
  imgSize3: {
    maxWidth: "300px",
    width: "80%",
    margin: "15px 20px 20px 20px",
    display: "block",
  },
  hyperlink: {
    textDecoration: "none",
    color: "#8277FF !important",
  },
  fontHeading: {
    marginBottom: "40px",
    fontSize: "28px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "22px",
    },
  },
  contentVert: {
    height: "650px",
    maxWidth: "450px",
    width: "70%",
    marginBottom: "70px",
    marginLeft: "30px",
    [theme.breakpoints.down("sm")]: {
      height: "600px",
      width: "70%",
      marginBottom: "50px",
    },
    [theme.breakpoints.down("xs")]: {
      height: "550px",
      width: "75%",
      margin: "0 auto",
      marginBottom: "40px",
    },
  },
  videoWrapperVert: {
    display: "flex",
    height: "100%",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
    borderRadius: "4px",
  },
  frameVert: {
    position: "absolute",
    height: "650px",
    maxWidth: "450px",
    width: "70%",
    [theme.breakpoints.down("sm")]: {
      height: "600px",
      width: "70%",
    },
    [theme.breakpoints.down("xs")]: {
      height: "550px",
      width: "75%",
    },
  },
  vidDescVert: {
    marginLeft: "30px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0px",
    },
  },
  highlighted: {
    backgroundColor: "#d8d2e7",
    width: "max-content",
    borderLeft: "5px solid #d8d2e7",
    borderRight: "5px solid #d8d2e7",
  },
}));

function ScanPaper() {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ maxWidth: "900px" }}>
      <div>
        <Typography variant="h5" className={classes.fontHeading}>
          Scan paper answer sheets
        </Typography>
      </div>
      <div display="block">
        <Typography className={classes.details} variant="body2">
          <a href="#howtoscanpaper">How to scan paper answer sheets</a>
          <br />
          <br />
          <a href="#bestprac">Best practices while scanning</a>
          <br />
          <br />
          <a href="#viewscan">View scan results</a>
          <br />
          <br />
          <a href="#manualauto">Manual vs. Automatic mode</a>
          <br />
          <br />
        </Typography>
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="howtoscanpaper"
        >
          How to scan paper answer sheets:
        </Typography>
        <Typography className={classes.details} variant="body2">
          You can scan answer sheets with our{" "}
          <span style={{ textDecoration: "underline" }}>Android</span> or{" "}
          <span style={{ textDecoration: "underline" }}>iOS</span> app, not our
          website.
          <br />
          <br />
          Once you log in to the app, select the class that your assessment is
          in:
          <br />
          <br />
        </Typography>
        <img
          style={{ maxWidth: "300px" }}
          className={classes.imgSize3}
          src={Selectaclass}
          alt="Answer Sheet"
        />
        <Typography className={classes.details} variant="body2">
          Then click the scan icon:
        </Typography>
        <img
          style={{ maxWidth: "300px" }}
          className={classes.imgSize3}
          src={Scan1}
          alt="Answer Sheet"
        />
        <Typography className={classes.details} variant="body2">
          If the assessment already has results, click options and then click
          scan:
        </Typography>
        <img
          style={{ maxWidth: "300px" }}
          className={classes.imgSize3}
          src={Scan2}
          alt="Answer Sheet"
        />
        <Typography className={classes.details} variant="body2">
          This will open your camera and initiate the scanning session.
          <br />
          <br />
          Next, simply point your camera at an answer sheet and the image will
          be automatically captured for you. Once the image is captured a ‘Scan
          completed’ pop up will appear:
        </Typography>
        <img
          style={{ maxWidth: "600px" }}
          className={classes.imgSize3}
          src={Autocaptured}
          alt="Autocaptured"
        />
        <Typography className={classes.details} variant="body2">
          Repeat this process with all of the answer sheets, and once done,
          click Submit:
        </Typography>
        <img
          style={{ maxWidth: "300px" }}
          className={classes.imgSize3}
          src={Clicksubmit}
          alt="click submit"
        />
        <Typography className={classes.details} variant="body2">
          Student grades will now be ready for you in the results section.
        </Typography>
        <Typography className={classes.highlighted} variant="h6" id="bestprac">
          Best practices while scanning:
        </Typography>
        <ul>
          <Typography
            style={{ fontWeight: 700 }}
            className={classes.details}
            variant="body2"
          >
            The four squares and barcode should be visible:
            <br />
            <br />
          </Typography>
          <li>
            <Typography className={classes.details} variant="body2">
              While scanning, the four squares and the barcode must be clearly
              visible, void of shadows, and not be covered by student
              handwriting:
            </Typography>
          </li>

          <img
            style={{ maxWidth: "300px" }}
            className={classes.imgSize3}
            src={Anchorsandbarcode}
            alt="Ancors and bar code"
          />
          <Typography
            style={{ fontWeight: 700 }}
            className={classes.details}
            variant="body2"
          >
            Take a bright photo void of shadows and glare:
            <br />
            <br />
          </Typography>
          <li>
            <Typography className={classes.details} variant="body2">
              Make sure that you are scanning in a well lit room with minimal
              glare or shadows on the answer sheet. If you must scan in dark
              conditions, there is a flashlight icon, but this can reduce
              scanning and grading accuracy.
              <br />
              <br />
            </Typography>
          </li>
          <Typography
            style={{ fontWeight: 700 }}
            className={classes.details}
            variant="body2"
          >
            Take a flat photo:
            <br />
            <br />
          </Typography>
          <li>
            <Typography className={classes.details} variant="body2">
              Make sure the paper is not bent or crumpled, and that your camera
              is directly above the page instead of at an angle:
            </Typography>
          </li>
          <img
            style={{ maxWidth: "600px" }}
            className={classes.imgSize3}
            src={Cameraangle}
            alt="Camera angle"
          />
          <Typography
            style={{ fontWeight: 700 }}
            className={classes.details}
            variant="body2"
          >
            Don’t have other papers visible in the background.
            <br />
            <br />
          </Typography>
          <li>
            <Typography className={classes.details} variant="body2">
              Anchors or barcodes from other papers will disrupt the scanning
              process.
            </Typography>
          </li>
        </ul>

        <Typography className={classes.highlighted} variant="h6" id="viewscan">
          View scan results:
        </Typography>
        <Typography className={classes.details} variant="body2">
          For multiple choice answer sheets, results are shown after each scan:
        </Typography>

        <img
          className={classes.imgSize3}
          src={Resultsshownaftereachscan}
          alt="Results after scan"
        />
        <br />
        <Typography className={classes.details} variant="body2">
          For written answer sheets, results are only shown after you scan all
          papers and click Submit:
        </Typography>
        <img
          className={classes.imgSize3}
          src={Submittoviewresults}
          alt="Subit to view results"
        />
        <br />
        <Typography
          className={classes.highlighted}
          variant="h6"
          id="manualauto"
        >
          Automatic vs. Manual mode:
        </Typography>
        <Typography className={classes.details} variant="body2">
          There are two scanning modes, Auto, and Manual:
        </Typography>
        <img
          className={classes.imgSize3}
          style={{ maxWidth: "600px" }}
          src={AutovsManualMode}
          alt="Subit to view results"
        />
        <Typography className={classes.details} variant="body2">
          SwiftGrade is meant to scan in Auto mode.
          <br />
          <br />
          In Auto mode, the image will be captured as soon as the answer sheet
          is in the correct position.
          <br />
          <br />
          In Manual mode, you need to manually click the shutter button to
          capture the image.
          <br />
          <br />
          Only use manual mode if scanning seems slow or is not working. This is
          usually because your phone’s processing power is too low for auto
          scanning.
        </Typography>
      </div>
    </div>
  );
}

function ScanningTips() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div style={{ display: "inline-block" }}>
        <div>
          <Typography variant="h5" className={classes.fontHeading}>
            Tutorial video - How to scan student answer sheets
          </Typography>
          <VideoVert videoLink="https://www.youtube.com/embed/Qe5fRtTxxMw" />
        </div>
      </div>
    </div>
  );
}

function ScanningPaperTopics() {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route path={`${path}/scan-paper-answer-sheets`}>
          <ScanPaper />
        </Route>
        <Route path={`${path}/tips-for-scanning-tutorial`}>
          <ScanningTips />
        </Route>
      </Switch>
    </>
  );
}

export default ScanningPaperTopics;
